import { useCallback } from "react";

export default function CollectedProductActions({
  setCollectedProductActionId,
  adminFetch,
  apiBaseUrl,
  readApiJson,
  fetchCollectedProducts,
  fetchAdminProducts,
  fetchPositionWorkspaceData,
  setAdminToast,
  locale,
  setAdminError
}) {
  const importCollectedProduct = useCallback(async (collectedProductKey) => {
    setCollectedProductActionId(String(collectedProductKey || ""));
    try {
      const response = await adminFetch(`${apiBaseUrl}/admin/collected-products/${encodeURIComponent(collectedProductKey)}/import`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({})
      });
      const data = await readApiJson(response);
      if (!response.ok) {
        throw new Error(data.message || "Import collected product failed");
      }

      await Promise.all([
        fetchCollectedProducts(),
        fetchAdminProducts(),
        fetchPositionWorkspaceData()
      ]);
      setAdminToast(
        data?.alreadyImported
          ? (locale === "zh" ? "该采集商品已在选品中心" : "Collected product already exists in merchandising")
          : (locale === "zh" ? "已加入选品中心" : "Collected product added to merchandising")
      );
    } catch (err) {
      if (err.message !== "Session expired") {
        setAdminError(err.message || "Import collected product failed");
      }
    } finally {
      setCollectedProductActionId("");
    }
  }, [
    adminFetch,
    apiBaseUrl,
    fetchAdminProducts,
    fetchCollectedProducts,
    fetchPositionWorkspaceData,
    locale,
    readApiJson,
    setAdminError,
    setAdminToast,
    setCollectedProductActionId
  ]);

  const removeCollectedProduct = useCallback(async (collectedProductKey) => {
    setCollectedProductActionId(String(collectedProductKey || ""));
    try {
      const response = await adminFetch(`${apiBaseUrl}/admin/collected-products/${encodeURIComponent(collectedProductKey)}/import`, {
        method: "DELETE"
      });
      const data = await readApiJson(response);
      if (!response.ok) {
        throw new Error(data.message || "Remove collected product failed");
      }

      await Promise.all([
        fetchCollectedProducts(),
        fetchAdminProducts(),
        fetchPositionWorkspaceData()
      ]);
      setAdminToast(locale === "zh" ? "已移出选品池" : "Collected product removed from merchandising");
    } catch (err) {
      if (err.message !== "Session expired") {
        setAdminError(err.message || "Remove collected product failed");
      }
    } finally {
      setCollectedProductActionId("");
    }
  }, [
    adminFetch,
    apiBaseUrl,
    fetchAdminProducts,
    fetchCollectedProducts,
    fetchPositionWorkspaceData,
    locale,
    readApiJson,
    setAdminError,
    setAdminToast,
    setCollectedProductActionId
  ]);

  return {
    importCollectedProduct,
    removeCollectedProduct
  };
}
